angular.module('zc.zenclerkS')

  .component('zcsAnalytics', {
    templateUrl: '/templates/zenclerk_s/sites/analytics/analytics.html',
    bindings: {
      project: '<',
    },
    controller: zcsAnalyticsController
  });

zcsAnalyticsController.$inject = ['ZcsOemService'];
function zcsAnalyticsController(ZcsOemService) {
  const vm = this;

  this.$onInit = () => {
    vm.initialized = true;
    vm.ZcsOemService = ZcsOemService;
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/analytics/analytics.component.js